import { useEffect } from "react";

const useReturnToHome = () => {
  const { pathname, hash } = window.location;
  const searchParams = hash.split("=")[1] || "";
  const activeSession = sessionStorage.getItem("active");
  const isHome = hash ? hash === "#/" : pathname === "/";
  const isFromAdvert = searchParams.toLowerCase() === "swiftsavings";

  useEffect(() => {
    if (!activeSession && !isHome && !isFromAdvert)
      window.location.replace("#/");
  }, [activeSession, isHome, isFromAdvert]);
};

export default useReturnToHome;
